import LevelCollection from '@/classes/LevelCollection';
import TariffCollection from '@/classes/TariffCollection';
class Employee {
    type = "employee";
    userId;
    //public email: string;
    levelHoursLeft;
    endOfEmployment;
    closedReportsDate;
    levels = new LevelCollection();
    employeeFullName;
    tariffs = new TariffCollection();
    employeeType = '';
    teamManagerIds;
    employmentDate;
    firstName;
    lastName;
    constructor(emp) {
        this.firstName = emp.firstName;
        this.lastName = emp.lastName;
        if (emp.levels !== undefined) {
            const levels = emp.fixedBenefits !== null ? [...emp.levels, ...emp.fixedBenefits] : emp.levels;
            this.levels.convertObjectsFromJson(levels);
        }
        this.userId = emp.userId || emp.id;
        //this.email = emp.email;
        this.levelHoursLeft = emp.levelHoursLeft;
        if (emp.endOfEmployment !== null) {
            this.endOfEmployment = window.dateHandler.formatDateNoTime(emp.endOfEmployment);
        }
        else {
            this.endOfEmployment = emp.endOfEmployment;
        }
        this.closedReportsDate = window.dateHandler.formatDateNoTime(emp.closedReportsDate);
        this.employeeFullName = this.firstName + " " + this.lastName;
        if (emp.tariffs !== undefined) {
            this.tariffs.convertFromJson(emp.tariffs);
        }
        this.employeeType = emp.type || '';
        this.teamManagerIds = emp.teamManagerIds || '';
        this.employmentDate = window.dateHandler.formatDateNoTime(emp.employmentDate);
    }
    getCurrentLevel() {
        return this.levels.getCurrentLevel();
    }
    getLevelForDate(date) {
        const value = this.levels.getLevelForFixedDate(date);
        return value;
    }
}
export default Employee;
